import { DEFAULT_PAGE_LIMIT } from "fond/constants";
import { BasePagination } from "fond/types";

export const pageNumberForPaginationSet = (set: BasePagination): number => {
  return Math.floor(set.Start / (set.Limit ?? DEFAULT_PAGE_LIMIT)) + 1;
};
